<div class="flex flex-column gap-small pt-2">
    <div>{{ 'user.activateUser.info' | translate }}</div>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="user.activateUser.activate" (primaryClickEvent)="activateUser()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
